module.exports = __webpack_public_path__ + "static/media/finish-exercise.9832c8aa.svg";